import { message } from "ant-design-vue";
import { repositoryEvents } from "@/src/constants/codebaseConstants.js";
import eventBus from "@/src/utils/eventBus.js";
import CodeService from "@/src/api/CodeService.js";

export const updateRepository = async (repoId, payload) => {
  try {
    const response = await CodeService.base.repos.update(repoId, payload);
    if (response?.success) {
      message.success("Repository updated successfully");
      eventBus.emit("repository-manipulated", repositoryEvents.UPDATED);
      return response;
    }
    if (response?.error) {
      message.error(response.error);
      return response;
    }
    message.error("Failed to update repository");
    return response;
  } catch (error) {
    console.error("Failed to update repository:", error);
    message.error("An error occurred while updating the repository");
    return null;
  }
};
